export default __webpack_public_path__ + "static/map-9a57f96aaccb138bb53a68f9d71b4d7e.webp";